import { z } from 'zod';

export const getDocumentsV2Schema = z.object({
  xprocess: z.string().optional(),
  ngay_ct1: z.string().nullable().optional(),
  ngay_ct2: z.string().nullable().optional()
});

export const getDocumentsV2InitialValues = {
  xprocess: '2',
  ngay_ct1: null,
  ngay_ct2: null
};
